import React from "react";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import InstagramIcon from "@mui/icons-material/Instagram";
import FacebookIcon from "@mui/icons-material/Facebook";
import LanguageIcon from "@mui/icons-material/Language";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import MusicNoteIcon from "@mui/icons-material/MusicNote";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import { Link } from "react-router-dom";
import Image2 from "../asset/WebLogos/FinalLogo-30.png";

function Footer() {
  return (
    <footer className="bg-black text-white pt-14 lg:pt-16 overflow-hidden">
      <div className="w-full px-4 sm:px-8 md:px-12 lg:px-16 xl:px-20 2xl:px-28">
        {/* Equal-width, equal-gap grid for all four columns; items-stretch (default)
            makes every column the same height, and h-full + justify-between on each
            column pushes its last piece of content down to a shared baseline. */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-x-10 gap-y-12 lg:gap-x-12 pb-12">
          {/* Company */}
          <div className="flex flex-col h-full justify-between">
            <div>
              <div className="mb-4">
                <img
                  src={Image2}
                  alt="KeyMech Design"
                  className="max-w-[180px] sm:max-w-[220px] h-auto object-contain"
                />
              </div>

              <p className="text-[#b5b5b5] text-sm leading-10">
                <div
                  className="text-[#b5b5b5] text-sm leading-8 space-y-2"
                  style={{ fontFamily: "sans-serif" }}
                >
                  <p>
                    <span className="font-semibold text-[#d72bbf]">Speed:</span> Rapid execution,
                    on-time delivery.
                  </p>

                  <p>
                    <span className="font-semibold text-[#d72bbf]">Quality:</span> Precision in
                    every detail.
                  </p>

                  <p>
                    <span className="font-semibold text-[#d72bbf]">Excellence:</span> Delivering
                    beyond expectations.
                  </p>
                </div>

              </p>
            </div>
          </div>

          {/* Services - Clickable Link */}
          <Link
            to="/service"
            className="flex flex-col h-full justify-between group cursor-pointer hover:opacity-80 transition-opacity"
          >
            <div>
              <h3 className="text-xl font-semibold mb-5 group-hover:text-[#d72bbf] transition-colors">Services</h3>
              <ul className="space-y-3 text-[#b5b5b5] text-sm">
                <li>• Prototyping</li>
                <li>• CAD Design</li>
                <li>• 3D Printing</li>
                <li>• Component Sourcing</li>
                <li>• Reverse Engineering</li>
                <li>• PCB Design Fabrication</li>
                <li>• Electronics Circuit Design</li>
                <li>• Research and Development</li>
                <li>• Embedded Systems Development</li>

              </ul>
            </div>
          </Link>

          {/* Contact */}
          <div className="flex flex-col h-full justify-between">
            <div>
              <h3 className="text-xl font-semibold mb-6">Contact</h3>

              <div className="flex flex-col gap-5">
                {/* Pakistan Contact */}
                <div>
                  <p className="text-[#d72bbf] text-xs font-semibold uppercase mb-3 tracking-wide">
                    Pakistan
                  </p>
                  <div className="flex flex-col gap-2.5">
                    <div className="flex items-start gap-3">
                      <LocationOnIcon sx={{ fontSize: 20 }} className="text-[#d72bbf] mt-0.5 shrink-0" />
                      <a
                        href="https://maps.app.goo.gl/uc2tdmaukHwohDv59"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-[#b5b5b5] text-sm hover:text-white transition"
                      >
                        View Our Location
                      </a>
                    </div>
                    {/* Pakistan WhatsApp */}
                    <div className="flex items-start gap-3">
                      <a
                        href="https://wa.me/923205504858"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="flex items-center gap-3 group"
                      >
                        <WhatsAppIcon sx={{ fontSize: 20 }} className="text-[#d72bbf] shrink-0" />
                        <span className="text-[#b5b5b5] text-sm group-hover:text-white transition">
                          Pakistan Support WhatsApp
                        </span>
                      </a>
                    </div>
                  </div>
                </div>

                {/* UK Contact */}
                <div className="pt-4 border-t border-[#1f1f1f]">
                  <p className="text-[#d72bbf] text-xs font-semibold uppercase mb-3 tracking-wide">
                    United Kingdom
                  </p>
                  <div className="flex flex-col gap-2.5">
                    <div className="flex items-start gap-3">
                      <LocationOnIcon sx={{ fontSize: 20 }} className="text-[#d72bbf] mt-0.5 shrink-0" />
                      <a
                        href="https://share.google/xL4yaQ7XzPNe6ZiVf"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-[#b5b5b5] text-sm hover:text-white transition"
                      >
                        View Our Location
                      </a>
                    </div>
                    {/* UK WhatsApp */}
                    <div className="flex items-start gap-3 pt-1">
                      <a
                        href="https://wa.me/447804571006"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="flex items-center gap-3 group"
                      >
                        <WhatsAppIcon sx={{ fontSize: 20 }} className="text-[#d72bbf] shrink-0" />
                        <span className="text-[#b5b5b5] text-sm group-hover:text-white transition">
                          UK Support WhatsApp
                        </span>
                      </a>
                    </div>
                  </div>
                </div>

                {/* Website */}
                <div className="flex items-start gap-3 pt-0">
                  <LanguageIcon sx={{ fontSize: 20 }} className="text-[#d72bbf] mt-0.5 shrink-0" />
                  <a
                    href="https://www.keymechdesigns.org"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-[#b5b5b5] text-sm hover:text-white transition break-all"
                  >
                    www.keymechdesigns.com
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* Connect & Newsletter */}
          <div className="flex flex-col h-full justify-between">
            <div>
              <h3 className="text-xl font-semibold mb-6">Connect</h3>

              <div className="flex flex-wrap gap-4 mb-8">
                <a
                  href="https://www.linkedin.com/company/86471086/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-11 h-11 rounded-full border border-[#333] flex items-center justify-center hover:bg-gradient-to-r hover:from-[#ff2ec4] hover:to-[#6d2ca0] hover:border-transparent transition-all duration-300"
                >
                  <LinkedInIcon />
                </a>

                <a
                  href="https://www.facebook.com/share/1BEUqEqrYz/?mibextid=wwXIfr"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-11 h-11 rounded-full border border-[#333] flex items-center justify-center hover:bg-gradient-to-r hover:from-[#ff2ec4] hover:to-[#6d2ca0] hover:border-transparent transition-all duration-300"
                >
                  <FacebookIcon />
                </a>

                <a
                  href="https://www.instagram.com/keymechdesigns"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-11 h-11 rounded-full border border-[#333] flex items-center justify-center hover:bg-gradient-to-r hover:from-[#ff2ec4] hover:to-[#6d2ca0] hover:border-transparent transition-all duration-300"
                >
                  <InstagramIcon />
                </a>

                <a
                  href="https://www.tiktok.com/@keymech.designs?_r=1&_t=ZS-977VJ4KKCtc"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-11 h-11 rounded-full border border-[#333] flex items-center justify-center hover:bg-gradient-to-r hover:from-[#ff2ec4] hover:to-[#6d2ca0] hover:border-transparent transition-all duration-300"
                >
                  <MusicNoteIcon />
                </a>
              </div>
            </div>

            <div>
              <h4 className="text-lg font-semibold mb-4">Newsletter</h4>

              <div className="flex flex-col gap-3">
                <input
                  type="email"
                  placeholder="Enter your email"
                  className="w-full bg-[#111] border border-[#333] rounded-lg px-4 py-3 text-sm text-white focus:outline-none focus:border-[#d72bbf]"
                />
                <button className="bg-gradient-to-r from-[#ff2ec4] to-[#6d2ca0] text-white py-3 rounded-lg text-sm font-medium hover:opacity-90 transition">
                  Subscribe
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-[#1f1f1f] py-6 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-[#808080] text-sm text-center md:text-left">
            © {new Date().getFullYear()} KeyMech Design. All Rights Reserved.
          </p>
          <p className="text-[#808080] text-sm text-center md:text-right">
            Engineering • Electronics • Product Development
          </p>
        </div>
      </div>

      <div className="h-2 w-full bg-gradient-to-r from-[#ff2ec4] to-[#6d2ca0]" />
    </footer>
  );
}

export default Footer;